
import {Button, DatePicker, Icon, message, Modal, Radio, Select, Spin} from "antd";
import React from "react";
import { CustomRow, CustomCol } from "../../components/Custom";

import { Row, Col, Form, InputNumber } from "antd";
import { mapAccountingRecordDataRange } from "../../axios/dictionaries";
import {post, postFrom} from "../../axios";
import {
    API_merchant_findAll,
    API_building_findBuildingList,
    API_Merchant_getCycleList,
    API_Merchant_getScheduleCycleExpenseDetailsList, API_Merchant_getPeriodicCollectionTotalAmount
} from "../../axios/config";
import { isDateRange } from "../../utils/validate";
import { formatTime } from "../../utils";
import moment from "moment";
import {
    fetchCreateDetailsLog,
    fetchAccountingRecordGet,
} from "../../services/accountingRecord";
/**
 * @Author: zhao - 🍉
 * @Date: 2021-12-17 16:33:28
 * @LastEditTime: 2021-12-22 11:54:43
 * @LastEditors: zhao - 🍉
 * @Description: 商户对账单 -编辑
 * @FilePath: /zhzj-admin/src/page/AccountingRecord/update.jsx
 */
class SettlementUpdate extends React.Component {

    state = {
        id: null,
        visible: false,
        dataInfo: {},
        merchantList: [],
        buildingList: [],
        cycleList:[],
        cycleExpenseList:[],
        dataLoading: false,
        maxCollectionAmount:999999,
        submitLoading: false,
    };
    open(id = null) {
        if (id) {
            this.postAccountingRecordGet(id).then((res) => {
                this.postBuildingList(res.merchantId)
            });
        }
        this.postMerchantList();

        this.setState({ visible: true, id });
        return new Promise((resolve, reject) => {
            this.monitor = { resolve, reject };
        });
    }
    close() {
        this.setState({ visible: false ,cycleList:[]});
        this.props.form.resetFields();
    }


    postBuildingList(merchantId) {
        postFrom({ url: API_building_findBuildingList, data: { merchantId } })
            .then((res) => {
                this.setState({ buildingList: res });
            })
            .catch((err) => {
                message.error(err.message || "获取小区/楼栋列表失败");
            });
    }

    postMerchantList() {
        postFrom({
            url: API_merchant_findAll,
            data: {},
        })
            .then((res) => {
                let merchantList = res.map((item) => ({
                    title: item.shortName,
                    value: item.id,
                    name: item.name,
                    isJr: item.isJr,
                    zjbDataSync: item.zjbDataSync,
                }));
                this.setState({ merchantList });
            })
            .catch((err) => {
                message.error(err.message || "获取商户列表失败");
                this.setState({ loading: false });
            });
    }
    postSubmit(data) {
        const post =  fetchCreateDetailsLog;
        this.setState({ submitLoading: true });

        return post(data).finally((err) => {
            this.setState({ submitLoading: false });
        });
    }
    postAccountingRecordGet(id) {
        this.setState({ dataLoading: true });
        return fetchAccountingRecordGet({ accountingRecordLogId: id })
            .then((res) => {
                const value = this.parseRes(res)
                this.props.form.setFieldsValue(value);
                return value
            })
            .finally(() => {
                this.setState({ dataLoading: false });
            });
    }

    parseRes(res) {
        const result = {
            buildingIds: res.buildingIds || [],
            scheduleCycleId: res.scheduleCycleId,
            dataRange: 1,
            endDate: moment(res.endDate),
            merchantId: res.merchantId,
            paymentDate: moment(res.paymentDate),
            startDate: moment(res.startDate),
            advanceBillSettle:res.advanceBillSettle===1?true:false,
            historyAdvanceBillSettle:res.historyAdvanceBillSettle===1?true:false,
            _date: moment(res.year + "-" + res.month),
        };
        return result;
    }

    parseReq(data) {
        data.startDate = formatTime(data.startDate, "YYYY-MM-DD");
        data.endDate = formatTime(data.endDate, "YYYY-MM-DD");
        data.paymentDate = formatTime(data.paymentDate, "YYYY-MM-DD");
        data.buildingIds = data.buildingIds || [];
        data.year = formatTime(data._date, "YYYY");
        data.month = formatTime(data._date, "MM");
        data.dataRange=1;
        data.advanceBillSettle=data.advanceBillSettle?1:2;
        data.historyAdvanceBillSettle = data.historyAdvanceBillSettle?1:2;
        return { ...data, _date: undefined };
    }

    handleMerchantChange = (e) => {
        // 更新楼栋列表
        this.postScheduleCycle(e);
    };
    handleCycleExpenseChange =(e) =>{

        let { cycleExpenseList } = this.state;
       for(var i=0;i<cycleExpenseList.length;i++){
           if(cycleExpenseList[i].id===e){
               this.setState({ maxCollectionAmount:cycleExpenseList[i].collectionAmount});
               this.props.form.setFieldsValue({transferAmount:cycleExpenseList[i].collectionAmount});
           }
       }


    }

    postScheduleCycle = (e) =>{
        this.setState({ cycleList: [],cycleExpenseList:[]});
        this.props.form.setFieldsValue({scheduleCycleId:null,_date:null,cycleExpenseDetailsId:null});
        //获取商户的租金汇集计划
        postFrom({ url: API_Merchant_getCycleList, data: { merchantId:e } })
            .then((res) => {
                this.setState({ cycleList: res });
            })
            .catch((err) => {
                message.error(err.message || "获取小区/楼栋列表失败");
            });

    }



    postScheduleCycleExpenseDetails = (e) =>{
        this.setState({ cycleExpenseList: [] });
        //获取商户的租金汇集计划
        postFrom({ url: API_Merchant_getScheduleCycleExpenseDetailsList, data: { merchantCollectionScheduleCycleId:e } })
            .then((res) => {
                this.setState({ cycleExpenseList: res });
            })
            .catch((err) => {
                message.error(err.message || "获取小区/楼栋列表失败");
            });

    }

    //获取汇总金额
    postPeriodicCollectionTotalAmount = (e) => {
        this.props.form.validateFields((err, values) => {
            if (err) return;
            const data = this.parseReq(values);
            //获取商户的租金汇集计划
            post({url: API_Merchant_getPeriodicCollectionTotalAmount, data: data})
                .then((res) => {
                    console.log(res);
                    this.props.form.setFieldsValue({totalAmount:res.totalAmount,transferredAmount:res.transferredAmount,remainingAmount:res.remainingAmount});

                })
                .catch((err) => {
                    message.error(err.message || "获取周期已汇集金额失败！");
                });
            return;
        });
    }



    handleDataRangeChange = () => {
        // 重置已选中的楼栋
        this.props.form.setFieldsValue({ buildingIds: [] });
    };

    handleSubmit() {
        this.props.form.validateFields((err, values) => {
            if (err) return;
            values.id = this.state.id || undefined;
            if (!isDateRange(values.startDate, values.endDate)) return message.warning("开始日期不能晚于结束日期");
            const data = this.parseReq(values);
            this.postSubmit(data)
                .then(() => {
                    this.close();
                    this.monitor.resolve();
                    message.success("保存成功");
                })
                .catch((e) => {
                    message.error(e.message);
                });
        });
    }



    renderFooter() {
        return (
            <div className="app-modal-footer">
                <Button type="primary" onClick={this.handleSubmit.bind(this)} loading={this.state.submitLoading}>
                    保存
                </Button>
                <Button onClick={this.close.bind(this)}>取消</Button>
            </div>
        );
    }

    render() {
        const modalConfig = {
            title: this.state.id ? "划账结算" : "划账结算",
            visible: this.state.visible,
            footer: this.renderFooter(),
            width: 642,
            onCancel: () => this.close(),
        };
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const labelWidth = 100;
        const dataRange = getFieldValue("dataRange");
        return (
            <Modal {...modalConfig}>
                <Spin spinning={this.state.dataLoading}>
                    <div className="custom" style={{ padding: 20 }}>
                        <Form labelCol={{ span: 0 }} wrapperCol={{ span: 24 }}>
                            <Row>
                                <Col span={24}>
                                    <CustomRow>
                                        <CustomCol label="商户名称">
                                            {getFieldDecorator("merchantId", {
                                                rules: [{ required: true, message: "请选择" }],
                                            })(
                                                <Select
                                                    showSearch
                                                    // style={{ width: 275 }}
                                                    placeholder="请选择"
                                                    optionFilterProp={"children"}
                                                    onChange={this.handleMerchantChange}
                                                >
                                                    {this.state.merchantList.map((item, index) => (
                                                        <Select.Option value={item.value} key={item.value}>
                                                            {item.title}
                                                        </Select.Option>
                                                    ))}
                                                </Select>
                                            )}
                                        </CustomCol>
                                    </CustomRow>
                                    <CustomRow divider>
                                        <CustomCol labelStyle={{ width: labelWidth }} label="开始日期">
                                            {getFieldDecorator("startDate", {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: "请选择开始日期",
                                                    },
                                                ],
                                            })(<DatePicker placeholder="开始日期" />)}
                                        </CustomCol>
                                        <CustomCol labelStyle={{ width: labelWidth }} label="结束日期">
                                            {getFieldDecorator("endDate", {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: "请选择结束日期",
                                                    },
                                                ],
                                            })(<DatePicker placeholder="结束日期" />)}
                                        </CustomCol>
                                    </CustomRow>

                                    <CustomRow divider>
                                        <CustomCol labelStyle={{ width: labelWidth }} label="所属年月">
                                            {getFieldDecorator("_date", {
                                                rules: [{ required: true, message: "请选择所属年月" }],
                                            })(<DatePicker.MonthPicker placeholder="所属年月" month   onChange={(date) => {
                                                if(date){
                                                    var flag=false;
                                                    var month=date.format('YYYY-MM');
                                                    var cycleList=  this.state.cycleList;
                                                    if(cycleList!=null){

                                                        for(var i=0;i<cycleList.length;i++){
                                                            console.log(moment(cycleList[i].collectionDate).format('YYYY-MM'));
                                                            if(moment(cycleList[i].collectionDate).format('YYYY-MM')===month){
                                                                this.props.form.setFieldsValue({scheduleCycleId:cycleList[i].id});
                                                                flag=true;
                                                                this.postScheduleCycleExpenseDetails(cycleList[i].id);
                                                            }
                                                        }

                                                    }
                                                    if(!flag){
                                                        this.props.form.setFieldsValue({scheduleCycleId:null});
                                                    }
                                                }else{
                                                    this.props.form.setFieldsValue({scheduleCycleId:null});
                                                }
                                            }}/>)}
                                        </CustomCol>
                                        <CustomCol labelStyle={{ width: labelWidth }} label="汇集期数">
                                            {getFieldDecorator("scheduleCycleId", {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: "请输入汇集期数",
                                                    },
                                                ],
                                            })(
                                                <Select
                                                    showSearch
                                                    // style={{ width: 275 }}
                                                    placeholder="请选择"
                                                    disabled={true}
                                                    optionFilterProp={"children"}
                                                >
                                                    {this.state.cycleList.map((item, index) => (
                                                        <Select.Option value={item.id} key={item.id}>
                                                            第{item.number}期
                                                        </Select.Option>
                                                    ))}
                                                </Select>
                                            )}
                                        </CustomCol>
                                    </CustomRow>
                                    <CustomRow divider>
                                        <CustomCol labelStyle={{ width: labelWidth }} label="预交账单结清">
                                            {getFieldDecorator('advanceBillSettle', {
                                                rules: [{ required: true, message: '请选择预交账单是否结清' }],
                                            })(
                                                <Radio.Group >
                                                    <Radio value={false}>不结清</Radio>
                                                    <Radio value>结清</Radio>
                                                </Radio.Group>
                                            )}
                                        </CustomCol>
                                        <CustomCol labelStyle={{ width: labelWidth }} label="历史预交结清">
                                            {getFieldDecorator('historyAdvanceBillSettle', {
                                                rules: [{ required: true, message: '请选择历史预交是否结清' }],
                                            })(
                                                <Radio.Group >
                                                    <Radio value={false}>不结清</Radio>
                                                    <Radio value>结清</Radio>
                                                </Radio.Group>
                                            )}
                                        </CustomCol>
                                    </CustomRow>
                                    <CustomRow divider>
                                        <CustomCol label="费用类型" >
                                            {getFieldDecorator("cycleExpenseDetailsId", {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: "请选择费用类型",
                                                    },
                                                ],
                                            })(
                                                <Select
                                                    showSearch
                                                    placeholder="请选择"
                                                    optionFilterProp={"children"}
                                                    onChange={this.handleCycleExpenseChange}
                                                >
                                                    {this.state.cycleExpenseList.map((item, index) => (
                                                        <Select.Option value={item.id} key={item.id}>
                                                            {item.expenseName}
                                                        </Select.Option>
                                                    ))}
                                                </Select>
                                            )}
                                        </CustomCol>
                                        <CustomCol label="划账金额" >
                                            {getFieldDecorator("transferAmount", {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: "请输入划账金额",
                                                    },
                                                ],
                                            })(
                                                <InputNumber min={0.01}  max={this.state.maxCollectionAmount}/>
                                            )}
                                        </CustomCol>
                                    </CustomRow>

                                    <CustomRow divider>
                                        <CustomCol label="已汇集金额" >
                                            {getFieldDecorator("totalAmount", {
                                                rules: [
                                                    {
                                                        required: false,
                                                    },
                                                ],
                                            })(
                                                <InputNumber disabled={true}/>
                                            )}
                                        </CustomCol>
                                        <CustomCol label="已划付金额" >
                                            {getFieldDecorator("transferredAmount", {
                                                rules: [
                                                    {
                                                        required: false,
                                                    },
                                                ],
                                            })(
                                                <InputNumber disabled={true}/>
                                            )}
                                        </CustomCol>
                                    </CustomRow>
                                    <CustomRow divider>
                                        <CustomCol label="可划付金额" >
                                            {getFieldDecorator("remainingAmount", {
                                                rules: [
                                                    {
                                                        required: false,
                                                    },
                                                ],
                                            })(
                                                <InputNumber disabled={true}/>
                                            )}
                                        </CustomCol>
                                        <div style={{ textAlign: 'right', paddingLeft:10 , paddingTop:5 }}>
                                            <a onClick={this.postPeriodicCollectionTotalAmount} title={'计算已汇集金额及已划付金额'}>
                                                <svg t="1645169845664" className="icon" viewBox="0 0 1024 1024"
                                                     version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="18560"
                                                     width="32" height="32">
                                                    <path d="M905.92 592v295.04H611.04V592z" fill="#28D900"
                                                          opacity=".15" p-id="18561"></path>
                                                    <path
                                                        d="M872.8 531.04h-42.24a415.04 415.04 0 0 0-71.04-94.72 620.8 620.8 0 0 0-99.2-81.76 537.92 537.92 0 0 0-52.32-32H417.44a561.76 561.76 0 0 0-53.44 32A626.4 626.4 0 0 0 264.8 436c-86.88 88.32-119.84 180.96-96 277.76v4a121.76 121.76 0 0 0 8.16 27.2 180.16 180.16 0 0 0 40.16 58.56c56.32 56 149.6 86.72 283.04 87.52h49.12v11.04a45.92 45.92 0 0 0 8.96 25.92H499.2c-146.24 0-246.56-37.28-308.16-98.56a219.2 219.2 0 0 1-48-70.88 156.48 156.48 0 0 1-10.72-36.64c-28.32-115.36 14.72-220.8 105.92-313.6a668.16 668.16 0 0 1 105.28-86.24A602.88 602.88 0 0 1 400 288.96l5.12-2.56a20 20 0 0 1 8.64-1.92h197.6a17.12 17.12 0 0 1 8.48 2.08l5.12 2.56a550.08 550.08 0 0 1 56.48 33.92 668.64 668.64 0 0 1 105.28 86.56 436.8 436.8 0 0 1 86.08 121.44zM582.72 208l43.84-55.2a307.52 307.52 0 0 0-109.92-20A281.28 281.28 0 0 0 432 145.44c-6.24 1.92-11.84 3.84-16.96 5.92L454.56 208z m-155.68 27.04l-52.96-76.32a23.2 23.2 0 0 1-3.52-18.88 24.48 24.48 0 0 1 12-16 297.28 297.28 0 0 1 134.08-29.6A349.6 349.6 0 0 1 658.4 124.8a23.84 23.84 0 0 1 13.92 16 23.04 23.04 0 0 1-4.32 20.48l-60 75.68a25.76 25.76 0 0 1-20.32 9.6H448a26.08 26.08 0 0 1-21.28-10.88zM676.64 720h32v-32h32v-32h-32v-32h-32v32h-32v32h32v32z m106.24 83.36h96v32h-96z m0-52.16h96v32h-96zM720 752l-26.56 26.4-27.36-26.4-21.28 21.28L672 800l-27.2 25.92 21.28 21.12 26.56-26.4 27.36 26.4 21.28-21.12L713.92 800l26.56-26.24L720 752z m64-94.72h96v32h-96v-32z m123.2-107.52H611.04A42.08 42.08 0 0 0 568.96 592v295.04a42.08 42.08 0 0 0 42.08 42.08h294.88a42.24 42.24 0 0 0 42.24-42.08V592a42.24 42.24 0 0 0-42.24-42.24z m0 42.08v295.2H611.04V592h295.04z"
                                                        fill="#28D900" p-id="18562"></path>
                                                </svg>
                                            </a>
                                        </div>
                                    </CustomRow>

                                </Col>
                            </Row>
                        </Form>
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export default Form.create({ wrappedComponentRef: true })(SettlementUpdate);



// WEBPACK FOOTER //
// ./src/page/TransferRecordLog/settlementUpdate.jsx